import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShieldAlert, ShieldCheck, Shield, AlertTriangle } from 'lucide-react';

export default function RecommendationCard({ riskLevel }) {
    const data = {
        low: {
            title: 'Riesgo Bajo (Normal)',
            icon: <ShieldCheck size={32} />,
            color: 'var(--color-success)',
            bg: 'rgba(16, 185, 129, 0.1)',
            list: [
                '✅ Revise y limpie desagües.',
                '✅ Mantenga batería de celular > 50%.',
                '⛔ Evite tirar basura en las calles.'
            ]
        },
        medium: {
            title: 'Riesgo Medio (Alerta)',
            icon: <Shield size={32} />,
            color: 'var(--color-warning)',
            bg: 'rgba(245, 158, 11, 0.1)',
            list: [
                '✅ Prepare mochila básica de emergencia.',
                '✅ Suba documentos a un lugar alto.',
                '⛔ No cruce charcos si no ve el fondo.',
                '✅ Identifique su ruta de evacuación.'
            ]
        },
        high: {
            title: 'RIESGO ALTO (PELIGRO)',
            icon: <ShieldAlert size={32} />,
            color: 'var(--color-danger)',
            bg: 'rgba(239, 68, 68, 0.2)',
            list: [
                '🚨 ¡EVACUACIÓN INMEDIATA RECOMENDADA!',
                '✅ Diríjase al refugio más cercano.',
                '✅ Desconecte el interruptor eléctrico principal.',
                '⛔ NO CRUCE RÍOS NI CAÑADAS CRECIDAS.'
            ]
        }
    };

    const current = data[riskLevel] || data.low;

    return (
        <div className="card recommendation-card glass-effect" style={{ borderLeft: `4px solid ${current.color}` }}>
            <div className="rec-header">
                <div style={{ color: current.color }}>{current.icon}</div>
                <h3 style={{ marginLeft: 10 }}>{current.title}</h3>
            </div>

            <ul className="rec-list">
                {current.list.map((item, i) => (
                    <motion.li
                        key={i}
                        initial={{ opacity: 0, x: -10 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ delay: i * 0.1 }}
                    >
                        {item}
                    </motion.li>
                ))}
            </ul>
        </div>
    );
}
